import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';

type Props = {
    children: React.ReactNode;
    permission: string;
};

const PermissionRoute: React.FC<Props> = ({ children, permission }) => {
    const { user, permissions, loading } = useAuth();

    if (loading) return null;
    const hasPermission = user && permissions.includes(permission);

    return hasPermission ? <>{children}</> : <Navigate to="/Unauthorized" replace />;
};

export default PermissionRoute;
